import form from './form';
import index from './index';
import { Router } from '@/legacy/Router';

Router.get('award', index);
Router.get('award/:any', form);
